export const screenTypeMixin = {
  computed: {
    screenType() {
      if (this.$vuetify.breakpoint.xsOnly) return 'smartphone'
      else if (this.$vuetify.breakpoint.width <= 1024) return 'tablet'
      else if (this.$vuetify.breakpoint.width > 1024) return 'desktop'
      return ''
    }
  }
}
